import { render, staticRenderFns } from "./VerifyCodeDialog.vue?vue&type=template&id=18f2e899&scoped=true&"
import script from "./VerifyCodeDialog.vue?vue&type=script&lang=ts&"
export * from "./VerifyCodeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2e899",
  null
  
)

export default component.exports